<script setup lang="ts">
interface Props {
    keypath: TranslationKey;
    tag?: string;
    scope?: 'global' | 'parent';
    plural?: number | string;
}

const { scope = 'global' } = defineProps<Props>();
</script>

<template>
    <!-- eslint-disable-next-line vue/no-restricted-html-elements -->
    <i18n-t :keypath="keypath" :tag="tag" :scope="scope" :plural="plural">
        <template v-for="(_, name) in $slots" :key="name" #[name]>
            <slot :name="name" />
        </template>
    </i18n-t>
</template>
